module.exports = __webpack_public_path__ + "img/features_timeline.091c9291.png";